/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import 'react-awesome-slider/dist/styles.css';
import { useResponsiveValue } from '@theme-ui/match-media';
import Carousel from '../../Carousel';
import { FormattedMessage } from 'react-intl';
import { ProductType, RulesName, RulesType } from '../../../enums';
import { Typography } from '@material-ui/core';
import NbcuSwitch from '../../form/SwitchRecurrence';
import {formattedInvoiceCurrency} from "../../../utils/products";
import {translate} from "../../Translate";
import { existsAnyEssentialPlan } from '../../../utils/validations';

/**
 * @returns {undefined}
 */
const noop = () => {};
const ProductSelectionPage = ({
  history,
  productToUpgradeId,
  cleanOrder,
  resetProductExchange,
  updateInitialExchangeByDeviceCountry,
  addProduct,
  plans,
  user,
  intl,
  products,
  applyProductRules,
  isSingleSubscriptionClient,
  client,
}) => {

  if (productToUpgradeId) {
    const productToUpgradeIndex = plans.findIndex(
      (plan) => plan.id === productToUpgradeId
    );
    const productToUpgrade = plans[productToUpgradeIndex];
    plans.splice(productToUpgradeIndex, 1);
    plans.unshift(productToUpgrade);
  }

  const numberOfCards = useResponsiveValue([
    1,
    2,
    plans.length > 2 ? 2 : plans.length,
  ]);

  const getMonthlyOrYearlyPlans = (plans) => {
    if (plans.some(plan => plan.interval.unit === 'month')) {
      return getPlansByInterval(plans, 'month');
    }
    return getPlansByInterval(plans, 'year');
  }

  const getPlansByInterval = (plans, interval) => {
    return plans.filter(plan => plan.interval.unit === interval);
  }

  const switchRecurrenceRef = useRef(false);
  const [switchRecurrence, setSwitchRecurrence] = useState(!plans.some(plan => plan.interval.unit === 'month'));
  const [planState, setPlanState] = useState(getMonthlyOrYearlyPlans(plans));

  useEffect(() => {
    if (user) {
      history.replace('plans' + history.location.search);
    }
  }, []);

  const handleContinueClick = (product) => {
    resetProductExchange();
    cleanOrder();
    addProduct({ ...product });
    applyProductRules({ ruleType: RulesType.PURCHASE, ruleName: RulesName.PLAN_INCLUDE_ADDONS, productId: product.productID });
    const addOnsTotalLength = products.filter(product => product.productType === ProductType.ADD_ON && !product.hidden).length;
    if (isSingleSubscriptionClient || addOnsTotalLength === 0) {
      history.push('methods' + history.location.search);
    } else {
      history.push('subscriptions/addOns' + history.location.search);
    }
  };

  const handleSwitchPlan = () => {
    const updatedSwitchRecurrence = switchRecurrenceRef.current;
    if (!updatedSwitchRecurrence) {
      return setPlanState(plans.filter(plan => plan.interval.unit === 'month'));
    }
    return setPlanState(plans.filter(plan => plan.interval.unit === 'year'));
  }


  const formattedCurrencyToShow = formattedInvoiceCurrency(user?.country);
  let messageEssential = '';
  if (!switchRecurrenceRef.current && existsAnyEssentialPlan(plans)) {
    messageEssential = `*${translate(intl, 'SubscriptionManagement.addExtra.essentialMessage')}`
  }
  return null;
  return (
    <div className="MembershipSelectionPage">
      <div className="myaccount-title mx-5">
        <h4 className="text-title">
          <FormattedMessage
            id="MembershipSelectionPage.short.description.plan"
          />
        </h4>
        <div className="myaccount-title__swith-recurrence">
          <Typography component="h6">
            <FormattedMessage id="MembershipSelectionPage.recurrence.monthly.card" />
          </Typography>
          <NbcuSwitch checked={switchRecurrence} onChange={e => {
            setSwitchRecurrence(!switchRecurrence);
            switchRecurrenceRef.current = !switchRecurrence
            handleSwitchPlan();
          }} />
          <Typography component="h6">
            <FormattedMessage id="MembershipSelectionPage.recurrence.yearly.discount" />
          </Typography>
        </div>
      </div>
      <div
        className="MembershipPlans BuyPlans">
        <Carousel
          key={`Carousel ${numberOfCards}`}
          products={planState}
          allProducts={products}
          user={user}
          intl={intl}
          toggleForm={() => {}}
          carouselOptions={{
            numberOfCards,
          }}
          onSelect={(plan) => handleContinueClick(plan)}
          client={client}
        />
      </div>
      <h6 className="myaccount-title__short-description-bottom">
        {formattedCurrencyToShow &&
          <p>{formattedCurrencyToShow}</p>
        }
      </h6>
      <h6 className="myaccount-title__short-description-bottom">
        {messageEssential &&
          <p>{messageEssential}</p>
        }
      </h6>
    </div>
  );
};

ProductSelectionPage.defaultProps = {
  products: [],
  updateMembership: noop,
};

ProductSelectionPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
  }),
  plans: PropTypes.array,
  products: PropTypes.array,
  cleanOrder: PropTypes.func,
  addProduct: PropTypes.func,
  productToUpgradeId: PropTypes.string,
  applyProductRules: PropTypes.func,
  isSingleSubscriptionClient: PropTypes.bool.isRequired,
  client: PropTypes.string.isRequired
};
export default ProductSelectionPage;
